/**
 * SONA subject-pool entry. SONA fills a per-participant code into the study URL;
 * we keep it for the whole run and the server uses it to build the credit redirect.
 *
 * Several names are accepted because the parameter is whatever the study's SONA
 * URL defines. Matching ignores case.
 */
const SONA_ID_PARAMS = ['id', 'survey_code', 'surveycode', 'sona_id', 'sonaid', 'userid', 'user_id', 'uid'];

// Rejects an unfilled template such as %SURVEY_CODE% from a SONA preview.
const VALID_SONA_ID = /^[A-Za-z0-9_-]{1,64}$/;

const SESSION_KEYS = [
  'experimentSession',
  'participantId',
  'hasConsented',
  'consentedArm',
  'consentStartTime',
  'selectedTask',
  'prolificId',
  'prolificStudyId',
  'prolificSessionId',
  'prolificCompletionUrl',
  'prolificCompletionCode',
  'completionPlatform',
  'completionFailed',
];

export function readSonaId(search: string): string | null {
  const params = new URLSearchParams(search);
  for (const [key, value] of Array.from(params.entries())) {
    if (SONA_ID_PARAMS.includes(key.toLowerCase()) && VALID_SONA_ID.test(value.trim())) {
      return value.trim();
    }
  }
  return null;
}

/**
 * Run once at landing, before any other localStorage read. A different code means
 * a different student on the same browser, so the previous student's session must
 * not be resumed: their answers and credit would be attributed to the wrong person.
 */
export function captureSonaId(search: string, storage: Storage = localStorage): void {
  const incoming = readSonaId(search);
  const stored = storage.getItem('sonaId');

  if (incoming) {
    if (incoming !== stored) {
      SESSION_KEYS.forEach(key => storage.removeItem(key));
      storage.setItem('sonaId', incoming);
    }
    return;
  }

  // A fresh recruitment link with no code must not inherit an earlier student's.
  const isFreshOrgEntry = new URLSearchParams(search).has('org');
  if (isFreshOrgEntry && stored && !storage.getItem('experimentSession')) {
    storage.removeItem('sonaId');
  }
}
